import http from '../clients/Axios'

export default class NeracaAwalService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          filters_param =
            filters_param + '&filter[' + el + ']=' + filters[el].value
        }
      })
    }

    const res = await http.get(
      `/account/saldo/neraca/paginate?page[number]=${pageNumber}&page[size]=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get() {
    const res = await http.get(`/account/saldo/neraca`)
    return res
  }

  async add(form) {
    const res = await http.post('/account/saldo/neraca', form)
    return res
  }

  async update(form) {
    const res = await http.post(`/account/saldo/neraca/${form.id}`, form)
    return res
  }

  async print() {
    return http({
      url: '/account/saldo/neraca/print',
      method: 'GET',
      responseType: 'blob',
    })
  }

  async export() {
    const unixTime = Math.floor(Date.now() / 1000)
    return http({
      url: `/account/saldo/neraca/export?t=${unixTime}`,
      method: 'GET',
      responseType: 'blob',
    })
  }
}
